import { render, staticRenderFns } from "./menu-dialog.vue?vue&type=template&id=494802ad"
import script from "./menu-dialog.vue?vue&type=script&lang=js"
export * from "./menu-dialog.vue?vue&type=script&lang=js"
import style0 from "./menu-dialog.vue?vue&type=style&index=0&id=494802ad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports